import CloudUploadIcon from '@mui/icons-material/CloudUploadOutlined';
import { Box, Stack, Typography, useTheme } from '@mui/material';
import { useRef } from 'react';

interface Props {
    onFileSelect(files: FileList | null): void;
}

export default function PdfUploadDropzone({ onFileSelect }: Props) {
    const theme = useTheme();
    const fileInputRef = useRef<HTMLInputElement>(null);

    return (
        <Box
            component="div"
            role="region"
            aria-label="PDF upload"
            onDrop={(event: React.DragEvent<HTMLDivElement>) => {
                event.preventDefault();
                event.stopPropagation();
                onFileSelect(event.dataTransfer?.files);
            }}
            onDragOver={(event: React.DragEvent<HTMLDivElement>) => {
                event.preventDefault();
                event.stopPropagation();
            }}
            sx={{
                minHeight: '200px',
                minWidth: '200px',
                border: `1px dashed ${theme.palette.neutral.gray}`,
                borderRadius: '4px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '8px',
                p: 2,
            }}
        >
            <Stack alignItems="center" spacing={0.5}>
                <CloudUploadIcon sx={{ fontSize: 16, color: theme.palette.neutral.gray }} />
                <Typography variant="body2">Drag & drop your APS (PDF)</Typography>
                <Typography variant="body3">or</Typography>
                <label
                    style={{
                        display: 'inline-block',
                        padding: '8px 16px',
                        border: `1px solid ${theme.palette.primary.main}`,
                        backgroundColor: 'rgba(54, 120, 215, 0.08)',
                        color: theme.palette.primary.main,
                        cursor: 'pointer',
                        borderRadius: '4px',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '500',
                        lineHeight: '16px',
                        textAlign: 'center',
                    }}
                >
                    <input
                        type="file"
                        aria-label="Choose a PDF file"
                        accept=".pdf,application/pdf"
                        multiple={false}
                        ref={fileInputRef}
                        style={{ display: 'none' }}
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            event.preventDefault();
                            event.stopPropagation();
                            onFileSelect(event.target?.files);
                            event.target.value = '';
                        }}
                    />
                    Upload PDF
                </label>
                <Typography variant="body2">Max 10MB</Typography>
            </Stack>
        </Box>
    );
}
